import React from "react";
import { FloatingLabel, Form, Row } from "react-bootstrap";
import MyCollapse from "../Common/MyCollapse";
import MyIcon from "../Common/MyIcon";
import HelpButton from "../HelpContent/HelpButton";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";

export default function BillingInformation({
  handleOrganisationDetailsChange,
  organisationDetails,
  errors,
}) {
  return (
    <div>
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
        <>
          <h5 className=" d-flex align-items-center">
            <MyIcon Icon={BillingDetailsIcon} className="me-2" />
            <span className="ms-2">
              <span className="fw-bold me-2">Account Information:</span>
              <HelpButton helpKey="settings-organisation-settings-account-information" />{" "}
              <div className="small text-secondary">
                Provide your account management contact details.
              </div>
            </span>
          </h5>
        </>

        <hr className="my-3 text-secondary" />
        <div className="row">
          <div className="col-6">
            <Form.Check
              id="is_same_address"
              type="checkbox"
              label="My organisation  billing address is the same as organisation address"
              className=" ps-0  fs-6"
              checked={
                organisationDetails.customer_profiles.is_same_address === 1
              }
              onClick={() => {
                handleOrganisationDetailsChange({
                  target: {
                    name: "customer_profiles.is_same_address",
                    value:
                      organisationDetails.customer_profiles.is_same_address ===
                      1
                        ? 0
                        : 1,
                  },
                });
              }}
            />
          </div>
          <div className="col-6">
            <div className=" mb-2">
              <FloatingLabel label=" Invoicing Address:">
                <Form.Control
                  as="textarea"
                  name="customer_profiles.invoicing_address"
                  placeholder="Invoicing Address(including postcode)"
                  onChange={handleOrganisationDetailsChange}
                  value={
                    organisationDetails.customer_profiles.invoicing_address
                  }
                  disabled={
                    organisationDetails.customer_profiles.is_same_address === 1
                  }
                />
              </FloatingLabel>
            </div>
            {errors["customer_profiles.invoicing_address"] && (
              <div className="alert alert-danger">
                {errors["customer_profiles.invoicing_address"]}
              </div>
            )}
          </div>
        </div>
        <div className="my-3">
          <span className="fw-bold me-2"> Accounts contact:</span>
          <span>
            contact used for communications related to subscription's billing,
            e.g., invoices
          </span>
          <hr className="my-3 text-secondary" />
          <Row>
            <div className="col-6">
              <FloatingLabel label="Name:" className="mb-2">
                <Form.Control
                  name="customer_profiles.account_name"
                  placeholder="account_name"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.account_name}
                />
              </FloatingLabel>
              {errors["customer_profiles.account_name"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.account_name"]}
                </div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="Email:" className="mb-2">
                <Form.Control
                  type="email"
                  name="customer_profiles.account_email"
                  placeholder="Email"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.account_email}
                />
              </FloatingLabel>
              {errors["customer_profiles.account_email"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.account_email"]}
                </div>
              )}
            </div>{" "}
          </Row>
        </div>

        <div className="my-3">
          <span className="fw-bold me-2"> Support contact:</span>
          <span>
            contact used for communications related to the application
          </span>
          <hr className="my-3 text-secondary" />
          <Row>
            <div className="col-6">
              <FloatingLabel label="Name:" className="mb-2">
                <Form.Control
                  name="customer_profiles.support_name"
                  placeholder="Name"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.support_name}
                />
              </FloatingLabel>
              {errors["customer_profiles.support_name"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.support_name"]}
                </div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="Email:" className="mb-2">
                <Form.Control
                  type="email"
                  name="customer_profiles.support_email"
                  placeholder="Email"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.support_email}
                />
              </FloatingLabel>
              {errors["customer_profiles.support_email"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.support_email"]}
                </div>
              )}
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
}
